// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3zD3Y","col":"styles_col__3J0DH"};